import React, { Component } from 'react'
// import { FormGroup, FormLabel, Row, Col } from 'react-bootstrap'
// import { Field, ErrorMessage } from 'formik'
// import FontAwesomeIcon from '@fortawesome/react-fontawesome'
// import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'


class Schedule extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  render(){
    return (
      <h5 className="white-text">Coming soon...</h5>
    )
  }
}

export default Schedule